<div class="boxWhite">
  <h4>FINALIZAR JORNADA</h4>

  <button class="btn btnClose" (click)="close()">
    <img src="assets/img/icoClose.svg" alt="">
  </button>

  <div class="contModal">
    <div class="row">
      <div class="col-sm-5">
        <h6 class="clBlack">ID {{accion}}</h6>
        <p class="clGray mb-4">{{getConductor.visibleId}}</p>
      </div>
      <div class="col-sm-7">
        <h6 class="clBlack">nombre conductor</h6>
        <p class="clGray mb-4">{{getConductor.nombres}} {{getConductor.apellidoPaterno}}</p>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-5">
        <h6 class="clBlack">Hora</h6>
        <p class="clGray mb-4">{{getHora}}</p>
      </div>

      <div class="col-sm-7">
        <h6 class="clBlack">sucursal ORIGEN</h6>
        <p class="clRed mb-4 fw-medium">{{getConductor.jornadaEnCurso.sucursal.nombre}}</p>
      </div>

      <div class="col-sm-6">
        <h6 class="clBlack">Duración real jornada</h6>
        <p class="clGray mb-4">{{getTiempoEnEstadoHHmm}}</p>
      </div>

      <div class="col-sm-12">
        <div class="boxInsideModal bgLightGray mb-4 d-flex align-items-center justify-content-between">
          <div class="d-flex flex-column justify-content-center">
            <h6>ESTADO ACTUAL</h6>
            <p class="clLightBlue m-0 fw-medium"> {{getConductor.estado}}
              <!-- <span class="clBlack">({{getTiempoEnEstadoHHmm}})</span> -->
            </p>
          </div>
        </div>
      </div>

      <div class="col-sm-12" *ngIf="accion === 'JORNADA_TERMINADA'">
        <div class="boxInsideModal bgRed mb-4 d-flex align-items-center justify-content-between">
          <div class="d-flex flex-column justify-content-center">
            <h6>Estado</h6>
            <p class="clWhite m-0 fw-medium">{{getConductor.jornadaEnCurso.sucursal.nombre}}</p>
          </div>
          <button *ngIf="tienePermisoImprimirJornada()" class="btn" [disabled]="procesandoPdf" (click)="getFinJornadaPDF()">
            <div class="bigIcon bgBlack">
              <img src="assets/img/icoPrint.svg" alt="">
            </div>
          </button>
        </div>
      </div>

      <div class="col-12">
        <ng-select placeholder="Seleccionar motivo" [multiple]="false" [items]="listaMotivosCierre" bindLabel="motivo"
          [(ngModel)]="motivoCierreSeleccionado">
          <ng-template ng-label-tmp let-item="item">
            <span>{{ item.motivo }}</span>
          </ng-template>
        </ng-select>
      </div>

      <div class="mt-3 col-12">
        <textarea class="form-control mb-3" rows="3" [(ngModel)]="detalleCierre"></textarea>
      </div>

    </div>

  </div>

  <div class="footModal">
    <button (click)="finalizarJornada()" [disabled]="enviando" class="btn btnRed" *ngIf="accion === 'PREVIO_CIERRE' && tienePermisoFinalizarJornada()">
      <span *ngIf="enviando" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
      FINALIZAR
    </button>
    <button (click)="finalizarJornadaEImprimir()" [disabled]="enviando" class="btn btnBlack" *ngIf="accion === 'PREVIO_CIERRE' && tienePermisoFinalizarJornada()">
      <span *ngIf="enviando" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
      FINALIZAR & IMPRIMIR
    </button>
  </div>

</div>